import React from 'react';

const CircleExpired = ({ width, height, onClick }) => (
  <svg
    className="circle"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick} // Adiciona o evento onClick
    style={{ cursor: "pointer" }} // Adiciona um cursor de ponteiro para indicar que é clicável
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <rect width="24" height="24" fill="white" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="#dee123" />
    </g>
  </svg>
);

export default CircleExpired;